module.exports = __webpack_public_path__ + "assets/media/evening.48419d85.mp3";